// Static Data template field definitions — GENERATED from the reference template.
// Note: "Existing Client Reference Number" is added by hand on every worksheet; re-generating drops it.

export type FieldRequirement = "required" | "optional" | "conditional";

export type TemplateFieldDef = {
  name: string;
  requirement: FieldRequirement;
  // Plain-language trigger shown for conditional fields, e.g. "Required if Asbestos Present = Y".
  condition?: string;
};

const MAP_PERCENTAGE_OR_FRACTION = "Map either Percentage or Fraction";

// Keyed by worksheet name, workbook order (matches templateData's staticDataCard.worksheets).
export const STATIC_DATA_FIELDS: Record<string, TemplateFieldDef[]> = {
  "Charge Dates": [
    { name: "Short Code", requirement: "required" },
    { name: "Description", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "January", requirement: "optional" },
    { name: "February", requirement: "optional" },
    { name: "March", requirement: "optional" },
    { name: "April", requirement: "optional" },
    { name: "May", requirement: "optional" },
    { name: "June", requirement: "optional" },
    { name: "July", requirement: "optional" },
    { name: "August", requirement: "optional" },
    { name: "September", requirement: "optional" },
    { name: "October", requirement: "optional" },
    { name: "November", requirement: "optional" },
    { name: "December", requirement: "optional" },
  ],
  "Nominal Codes": [
    { name: "Code", requirement: "required" },
    { name: "Description", requirement: "required" },
    { name: "Account Type", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Income And Expenditure Flag", requirement: "optional" },
    { name: "Notes", requirement: "optional" },
  ],
  "Nominal Bank Code": [
    { name: "Reference", requirement: "required" },
    { name: "Description", requirement: "required" },
    { name: "Bank Account No", requirement: "optional" },
    { name: "Bank Sort Code", requirement: "optional" },
    { name: "Nominal", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
  ],
  Offices: [
    { name: "Office Name", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Number", requirement: "optional" },
    { name: "AddressLine1", requirement: "optional" },
    { name: "AddressLine2", requirement: "optional" },
    { name: "AddressLine3", requirement: "optional" },
    { name: "AddressLine4", requirement: "optional" },
    { name: "AddressLine5", requirement: "optional" },
    { name: "City", requirement: "optional" },
    { name: "County", requirement: "optional" },
    { name: "PostCode", requirement: "optional" },
    { name: "Country", requirement: "optional" },
    { name: "Telephone", requirement: "optional" },
  ],
  "Fiscal Period": [
    { name: "Description", requirement: "required" },
    { name: "Start Date", requirement: "required" },
    { name: "End Date", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Financial Period", requirement: "optional" },
    { name: "Period End Day", requirement: "optional" },
    { name: "Period End Month", requirement: "optional" },
  ],
  "Unit Types": [
    { name: "Name", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Description", requirement: "optional" },
    { name: "Notes", requirement: "optional" },
  ],
  LegalEntities: [
    { name: "Legal Entity No", requirement: "optional" },
    { name: "Name", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "AddressLine1", requirement: "optional" },
    { name: "AddressLine2", requirement: "optional" },
    { name: "AddressLine3", requirement: "optional" },
    { name: "AddressLine4", requirement: "optional" },
    { name: "City", requirement: "optional" },
    { name: "County", requirement: "optional" },
    { name: "PostCode", requirement: "optional" },
    { name: "Country", requirement: "optional" },
    { name: "VATNo", requirement: "optional" },
    { name: "ChargeDateCode", requirement: "optional" },
    { name: "Vat Return Frequency", requirement: "optional" },
  ],
  Freeholders: [
    { name: "Freeholder Name", requirement: "required" },
    { name: "Freeholder No", requirement: "optional" },
    { name: "AddressLine1", requirement: "optional" },
    { name: "AddressLine2", requirement: "optional" },
    { name: "AddressLine3", requirement: "optional" },
    { name: "AddressLine4", requirement: "optional" },
    { name: "City", requirement: "optional" },
    { name: "County", requirement: "optional" },
    { name: "PostCode", requirement: "optional" },
    { name: "Country", requirement: "optional" },
    { name: "CompanyNo", requirement: "optional" },
    { name: "Bank Account Name", requirement: "optional" },
    { name: "Bank Sort Code", requirement: "optional" },
    { name: "Bank Account no", requirement: "optional" },
    { name: "VATNo", requirement: "optional" },
    { name: "UnitGroundRentDefault", requirement: "optional" },
    { name: "CommissionRate", requirement: "optional" },
    { name: "CommisionRateType", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Default Telephone Description", requirement: "optional" },
    { name: "Default PhoneNumber", requirement: "optional" },
    { name: "Additional Telephone Description", requirement: "optional" },
    { name: "Additional Phone Number", requirement: "optional" },
    { name: "Default Email Address", requirement: "optional" },
    { name: "Use for Documents", requirement: "optional" },
    { name: "Use for Invoices", requirement: "optional" },
    { name: "Additional Email Address", requirement: "optional" },
    { name: "Additional Email  Use for Documents", requirement: "optional" },
    { name: "Additional Email  Use for Invoices", requirement: "optional" },
  ],
  Developments: [
    { name: "Development Name", requirement: "required" },
    { name: "Development Number", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "AddressLine1", requirement: "optional" },
    { name: "AddressLine2", requirement: "optional" },
    { name: "AddressLine3", requirement: "optional" },
    { name: "AddressLine4", requirement: "optional" },
    { name: "AddressLine5", requirement: "optional" },
    { name: "City", requirement: "optional" },
    { name: "County", requirement: "optional" },
    { name: "PostCode", requirement: "optional" },
    { name: "Country", requirement: "optional" },
    { name: "Property Types", requirement: "optional" },
    { name: "Accounting Basis", requirement: "optional" },
    { name: "PropertyServiceChargeTypeID", requirement: "optional" },
    { name: "Common Factors", requirement: "optional" },
    { name: "Asbestos Present?", requirement: "optional" },
    { name: "Asbestos Description", requirement: "conditional", condition: "Required if Asbestos Present = Y" },
    { name: "Development Description", requirement: "optional" },
    { name: "Handover Completed", requirement: "optional" },
    { name: "HandoverDate", requirement: "conditional", condition: "Required if Handover Completed = Y" },
    { name: "Charge Dates", requirement: "optional" },
    { name: "Grounds Only", requirement: "optional" },
    { name: "Ceased to Factor", requirement: "optional" },
    { name: "Ceased Date", requirement: "conditional", condition: "Required if Ceased to Factor = Y" },
    { name: "Nominal Bank Code", requirement: "optional" },
    { name: "Management Fee Nominal", requirement: "optional" },
    { name: "Purchase Ledger Bank Account", requirement: "optional" },
    { name: "Office", requirement: "optional" },
    { name: "Asbestos Survey Date", requirement: "optional" },
    { name: "AuthorityToAct", requirement: "optional" },
    { name: "InstructingAuthority", requirement: "optional" },
    { name: "Date Of Instruction", requirement: "optional" },
    { name: "Listed Building", requirement: "optional" },
    { name: "ManagementFeeChargeDateCodeID", requirement: "optional" },
    { name: "Vat Elected", requirement: "optional" },
    { name: "VATElectedFromDate", requirement: "conditional", condition: "Required if Vat Elected = Y" },
    { name: "Legal Entity", requirement: "optional" },
  ],
  Blocks: [
    { name: "Development", requirement: "required" },
    { name: "Block Number", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "AddressLine1", requirement: "optional" },
    { name: "AddressLine2", requirement: "optional" },
    { name: "AddressLine3", requirement: "optional" },
    { name: "AddressLine4", requirement: "optional" },
    { name: "AddressLine5", requirement: "optional" },
    { name: "City", requirement: "optional" },
    { name: "County", requirement: "optional" },
    { name: "PostCode", requirement: "optional" },
    { name: "Country", requirement: "optional" },
  ],
  Properties: [
    { name: "Development", requirement: "required" },
    { name: "Block Number", requirement: "required" },
    { name: "Property Unique Identifier", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Property ID", requirement: "optional" },
    { name: "AddressLine1", requirement: "optional" },
    { name: "AddressLine2", requirement: "optional" },
    { name: "AddressLine3", requirement: "optional" },
    { name: "AddressLine4", requirement: "optional" },
    { name: "AddressLine5", requirement: "optional" },
    { name: "City", requirement: "optional" },
    { name: "County", requirement: "optional" },
    { name: "PostCode", requirement: "optional" },
    { name: "Country", requirement: "optional" },
    { name: "Unit Type", requirement: "optional" },
    { name: "Property Service Charge Type", requirement: "optional" },
    { name: "VAT Elected", requirement: "optional" },
    { name: "FreeHolder", requirement: "optional" },
    { name: "Annual Ground Rent", requirement: "optional" },
    { name: "Float", requirement: "optional" },
    { name: "Management Fee", requirement: "optional" },
    { name: "Developer Fee", requirement: "optional" },
    { name: "Estimated Annual Expenditure", requirement: "optional" },
  ],
  Clients: [
    { name: "Property Unique Identifier", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Client No", requirement: "optional" },
    { name: "Client Name", requirement: "required" },
    { name: "Colloquial Name", requirement: "optional" },
    { name: "Description", requirement: "optional" },
    { name: "AddressLine1", requirement: "optional" },
    { name: "AddressLine2", requirement: "optional" },
    { name: "AddressLine3", requirement: "optional" },
    { name: "AddressLine4", requirement: "optional" },
    { name: "AddressLine5", requirement: "optional" },
    { name: "City", requirement: "optional" },
    { name: "County", requirement: "optional" },
    { name: "PostCode", requirement: "optional" },
    { name: "Country", requirement: "optional" },
    { name: "Entry Date", requirement: "optional" },
    { name: "Exit Date", requirement: "optional" },
    { name: "GarageSpace", requirement: "optional" },
    { name: "PaymentType", requirement: "optional" },
    { name: "ClientType", requirement: "optional" },
    { name: "Note of Interest", requirement: "optional" },
    { name: "Internal Client", requirement: "optional" },
    { name: "Default Email Address", requirement: "optional" },
    { name: "Use for Documents", requirement: "optional" },
    { name: "Use for Invoices", requirement: "optional" },
    { name: "Additional Email Address", requirement: "optional" },
    { name: "Additional Use for Documents", requirement: "optional" },
    { name: "Additional Use for Invoices", requirement: "optional" },
    { name: "Default Telephone Description", requirement: "optional" },
    { name: "Default Telephone", requirement: "optional" },
    { name: "Additional Telephone Description", requirement: "optional" },
    { name: "Additional Telephone", requirement: "optional" },
    { name: "Alternative Address Description", requirement: "optional" },
    { name: "Alternative Address - Internal", requirement: "optional" },
    { name: "Alternative Address - Billing", requirement: "optional" },
    { name: "Alternative Address - Forwarding", requirement: "optional" },
    { name: "Alternative AddressLine1", requirement: "optional" },
    { name: "Alternative AddressLine2", requirement: "optional" },
    { name: "Alternative AddressLine3", requirement: "optional" },
    { name: "Alternative AddressLine4", requirement: "optional" },
    { name: "Alternative AddressLine5", requirement: "optional" },
    { name: "Alternative Address City", requirement: "optional" },
    { name: "Alternative Address County", requirement: "optional" },
    { name: "Alternative Address Postal Code", requirement: "optional" },
    { name: "Alternative Address Country", requirement: "optional" },
  ],
  Apportionments: [
    { name: "Development_Name", requirement: "required" },
    { name: "Apportionment_Number", requirement: "required" },
    { name: "Description", requirement: "required" },
    { name: "Note", requirement: "optional" },
    { name: "Property Unique Identifier", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Percentage", requirement: "conditional", condition: MAP_PERCENTAGE_OR_FRACTION },
    { name: "Fraction", requirement: "conditional", condition: MAP_PERCENTAGE_OR_FRACTION },
  ],
  "Fund Schedules": [
    { name: "Development", requirement: "required" },
    { name: "Description", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Bank Nominal", requirement: "optional" },
    { name: "Nominal Code", requirement: "optional" },
    { name: "Apportion", requirement: "optional" },
    { name: "Block", requirement: "optional" },
    { name: "Charge Date Code", requirement: "optional" },
    { name: "Legal Entity", requirement: "optional" },
    { name: "FundScheduleChargeTypes", requirement: "optional" },
    { name: "VAT Elected", requirement: "optional" },
  ],
  "Fund Headers": [
    { name: "Fund Header Code", requirement: "required" },
    { name: "Description", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Vat Code", requirement: "optional" },
    { name: "Nominal Code", requirement: "optional" },
  ],
  "FundSchedule Billing Period": [
    { name: "Development", requirement: "required" },
    { name: "Fund Schedule", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Fiscal Period", requirement: "optional" },
    { name: "Fund Header", requirement: "optional" },
    { name: "Goods", requirement: "optional" },
    { name: "Total", requirement: "optional" },
    { name: "Adhoc Charge (one off Demand Added to Schedule)", requirement: "optional" },
    { name: "From Date", requirement: "optional" },
    { name: "To Date", requirement: "optional" },
    { name: "VAT", requirement: "optional" },
  ],
  "Job Types": [
    { name: "Description", requirement: "required" },
    { name: "Code", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Note", requirement: "optional" },
  ],
  "PL Accounts": [
    { name: "PL_Number", requirement: "required" },
    { name: "Alternative_AccountNo", requirement: "optional" },
    { name: "VAT", requirement: "optional" },
    { name: "Name", requirement: "required" },
    { name: "Existing Client Reference Number", requirement: "optional" },
    { name: "Colloquial_Name", requirement: "optional" },
    { name: "Addressline1", requirement: "optional" },
    { name: "Addressline2", requirement: "optional" },
    { name: "Addressline3", requirement: "optional" },
    { name: "Addressline4", requirement: "optional" },
    { name: "Addressline5", requirement: "optional" },
    { name: "City", requirement: "optional" },
    { name: "County", requirement: "optional" },
    { name: "Postcode", requirement: "optional" },
    { name: "Country", requirement: "optional" },
    { name: "Payment_Address", requirement: "optional" },
    { name: "Payment_Postcode", requirement: "optional" },
    { name: "Default_Job_Type", requirement: "optional" },
    { name: "Email_Description", requirement: "optional" },
    { name: "Email", requirement: "optional" },
    { name: "Email_Use_For_Documents", requirement: "optional" },
    { name: "Email_Use_For_Orders", requirement: "optional" },
    { name: "Email_Use_For_Bacs", requirement: "optional" },
    { name: "Email_Use_For_Warranty_Work_Orders", requirement: "optional" },
    { name: "Additional_Email_Description", requirement: "optional" },
    { name: "Additional_Email", requirement: "optional" },
    { name: "Additional_Email_Use_For_Documents", requirement: "optional" },
    { name: "Additional_Email_Use_For_Orders", requirement: "optional" },
    { name: "Additional_Email_Use_For_Bacs", requirement: "optional" },
    { name: "Additional_Email_Use_For_Warranty_Work_Orders", requirement: "optional" },
    { name: "Additional_Email_2_description_2", requirement: "optional" },
    { name: "Additional_Email_2", requirement: "optional" },
    { name: "Additional_Email_2_Use_For_Documents", requirement: "optional" },
    { name: "Additional_Email_2_Use_For_Orders", requirement: "optional" },
    { name: "Additional_Email_2_Use_For_Bacs", requirement: "optional" },
    { name: "Additional_Email_2_Use_For_Warranty_Work_Orders", requirement: "optional" },
    { name: "Additional_Email_3_Description", requirement: "optional" },
    { name: "Additional_Email_3", requirement: "optional" },
    { name: "Additional_Email_3_Use_For_Documents", requirement: "optional" },
    { name: "Additional_Email_3_Use_For_Orders", requirement: "optional" },
    { name: "Additional_Email_3_Use_For_Bacs", requirement: "optional" },
    { name: "Additional_Email_3_Use_For_Warranty_Work_Orders", requirement: "optional" },
    { name: "Additional_Email_4_Description", requirement: "optional" },
    { name: "Additional_Email_4", requirement: "optional" },
    { name: "Additional_Email_4_Use_For_Documents", requirement: "optional" },
    { name: "Additional_Email_4_Use_For_Orders", requirement: "optional" },
    { name: "Additional_Email_4_Use_For_Bacs", requirement: "optional" },
    { name: "Additional_Email_4_Use_For_Warranty_Work_Orders", requirement: "optional" },
    { name: "Payment_Type", requirement: "optional" },
    { name: "Invoice_GraceDays", requirement: "optional" },
    { name: "Bank_Name", requirement: "optional" },
    { name: "Sort_Code", requirement: "optional" },
    { name: "Account_No", requirement: "optional" },
    { name: "Telephone_Number_Description", requirement: "optional" },
    { name: "Telephone_Number", requirement: "optional" },
    { name: "Additional_Telephone_Description", requirement: "optional" },
    { name: "Additional_Telephone_Number", requirement: "optional" },
    { name: "Additional_Telephone_1_Description", requirement: "optional" },
    { name: "Additional_Telephone_1_Number", requirement: "optional" },
    { name: "H&S_Expiry", requirement: "optional" },
    { name: "H&S_Expiry_Date", requirement: "conditional", condition: "Required if H&S_Expiry = Y" },
    { name: "E_Insurance", requirement: "optional" },
    { name: "E_Insurance_Expiry_Date", requirement: "conditional", condition: "Required if E_Insurance = Y" },
    { name: "PL_Insurance", requirement: "optional" },
    { name: "PL_Insurance_Expiry_Date_", requirement: "conditional", condition: "Required if PL_Insurance = Y" },
    { name: "Aspestos_Awareness_", requirement: "optional" },
    { name: "Bank_Information_Requested_", requirement: "optional" },
    { name: "Bank_Information_Requested__Date_", requirement: "optional" },
    { name: "Bank_Information_Recieved_", requirement: "optional" },
    { name: "Bank_Information_Recieved_Date_", requirement: "optional" },
  ],
};
